
export default {
  name: 'SortDropdown',

  data: function () {
    return {
      isOpen: false,
    };
  },

  props: {
    active: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    activeValue: function () {
      return (this.options || []).find((t) => t.id === (this.active || 'default'))?.value;
    },
  },

  methods: {
    changeOpen: function () {
      this.isOpen = !this.isOpen;
    },
    changeSort: function (optionId) {
      this.isOpen = false;
      this.$emit('onChange', optionId);
    },
  },
};
